import { SidePanelDS, TextCapitalized, Spacer } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const AmountLimitSectionsCard = (props: {
  isInOpposition: boolean;
  monthlyAmountlimit: number;
  monthlyExpenses: number | null;
}) => {
  const { t } = useTranslation();

  if (props.isInOpposition) {
    return;
  }

  return (
    <SidePanelDS.Section verticalSpacing={2} horizontalSpacing={1.5}>
      <StyledTitle>
        <TextCapitalized>
          {t("cards.sidePanel.informations.title.amountLimit")}
        </TextCapitalized>
      </StyledTitle>
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <StyledSubTitle>
            <TextCapitalized>
              {t("cards.sidePanel.informations.title.expenses")}
            </TextCapitalized>
          </StyledSubTitle>
        }
        value={
          <StyledRow>
            <StyledSubTitle>
              {props.monthlyExpenses ?? 0} / {props.monthlyAmountlimit ?? 0}
            </StyledSubTitle>
            <Spacer x={0.5} />
            <StyledUnits>EUR</StyledUnits>
          </StyledRow>
        }
      />
      <Spacer y={1.5} />
      <StyledLine
        $percentage={
          props.monthlyExpenses
            ? (props.monthlyExpenses / props.monthlyAmountlimit) * 100
            : 0
        }
      />
    </SidePanelDS.Section>
  );
};

const StyledLine = styled.div<{ $percentage: number }>`
  width: 100%;
  border-bottom: 0.25rem solid ${colors["colors/borders/button/primary"]};
  border-radius: 2rem;
  border-image: linear-gradient(
      to right,
      ${colors["colors/accent/500"]} ${({ $percentage }) => $percentage}%,
      ${colors["colors/borders/button/primary"]}
        ${({ $percentage }) => $percentage}%
    )
    5;
`;

const StyledTitle = styled.div`
  ${typographies["Body/XL"]}
`;

const StyledSubTitle = styled.div`
  ${typographies["Body/L"]}
`;

const StyledUnits = styled.div`
  display: flex;
  ${typographies["Body/XXS"]}
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledRow = styled.div`
  display: flex;
`;
